"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Price = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./Price.css"));
var _uiKit = require("@cian/ui-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Price = props => {
  const {
    price,
    oldPrice,
    monthlyPrice,
    promoLabel,
    discountLabel,
    bankMortgageLabel
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: style['container']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['price']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['price-row']
  }, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, price)), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true,
    tablet: true
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading3, null, price)), oldPrice && /*#__PURE__*/React.createElement("span", {
    className: style['old-price']
  }, oldPrice)), monthlyPrice && /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "text-main-default"
  }, monthlyPrice)), /*#__PURE__*/React.createElement("div", {
    className: style['labels']
  }, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true,
    tablet: true
  }, discountLabel && /*#__PURE__*/React.createElement(_uiKit.Label, {
    background: "accent-positive-secondary",
    color: "accent-positive-primary"
  }, discountLabel)), promoLabel && /*#__PURE__*/React.createElement(_uiKit.Label, {
    background: "control-inverted-primary-default",
    color: "accent-positive-primary"
  }, promoLabel), bankMortgageLabel && /*#__PURE__*/React.createElement(_uiKit.Label, {
    background: "control-inverted-primary-default",
    color: "accent-main-primary"
  }, bankMortgageLabel)));
};
exports.Price = Price;